import { loadAnalytics, trackPageView } from './src/utils/analytics'

export const onInitialClientRender = () => {
  loadAnalytics()
}

export const onRouteUpdate = ({ location }) => {
  trackPageView(location)
}
